query DateCalcConsecutiveNightTotals(
  $endDate: Date!
  $rate: BigFloat!
  $startDate: Date!
) {
  dateCalcConsecutiveNightTotals(
    endDate: $endDate
    rate: $rate
    startDate: $startDate
  ) {
    extendedTotal
    dayTotal
    periodTotal
    partialPeriodDays
    fullPeriods
  }
}
